<template>
  <div id="repair">
     <div class="fiveStatus">
     <ul class="ul1">
         <li :class=" one ? 'orange' : 'black' ">
           <p class="p2"></p>
         </li>
         <li :class=" two ? 'orange' : 'black' ">
           <p class="p1"></p>
           <p class="p2"></p>
         </li>
         <li :class=" three ? 'orange' : 'black' ">
           <p class="p1"></p>
           <p class="p2"></p>
         </li>
         <li :class=" four ? 'orange' : 'black' ">
           <p class="p1"></p>
           <p class="p2"></p>
         </li>
         <li :class=" five ? 'orange' : 'black' ">
           <p class="p1"></p>
           <p class="p2"></p>
         </li>
     </ul>
	   <ul class="ul2">
        <li :class=" one ? 'orange' : 'black' ">未分配</li>
        <li :class=" two ? 'orange' : 'black' "> 已分配</li>
        <li :class=" three ? 'orange' : 'black' ">进行中</li>
        <li :class=" four ? 'orange' : 'black' ">已完成</li>
        <li :class=" five ? 'orange' : 'black' ">已回访</li>
	   </ul>
     </div>
     <div class="aboutRepair" ref="aboutRepair">
	     	<p class="type" v-if="items.type">报修类型：<span>{{items.type}}</span></p>
	     	<p class="address">报修位置：<span>{{items.address}}</span></p>
	     	<p class="clearfix contentTitle">报修内容：	<span class="content">{{items.content}}</span></p>

	     	<ul>
	     		<li :key='item.index' v-for="item in items.imgs" ><img :src="item.thumbPath"  @click="Big(item.path)"  /></li>
	     	</ul>
     </div>
    <!-- 接单人+电话+时间+开始时间+完成时间-->
     <div class="receive" ref="receive" v-if="this.status >= 2">
	     	<p>接单人：<span>{{this.receivePerson}}</span> </p>
	     	<p>联系电话：
	     		<span >{{this.mobile}}</span>
	     			<img src="/static/img/call.png" @click="phone()"/>
	     	</p>
	     	<p ref="receiveDate">接单时间：&nbsp;<span >{{this.receiveDate}}</span></p>
	     	<p ref="beginDate" v-if="this.status >= 3">开始时间：&nbsp;<span >{{this.beginDate}}</span></p>
	     	<p ref="finishDate" v-if="this.status >= 4">完成时间：&nbsp;<span>{{this.finishDate}}</span></p>
	     	<ul v-if="this.status >= 3">
		     		<li :key='item.index' v-for="item in finished">
		     			<img :src="item.thumbnailurl" @click="Big(item.fileurl)" />
		     		</li>
		    </ul>
       <div class="evaluatePart" v-if="this.status >= 4">
				 <input v-if="!evaluateContent" class="evaluateBtn" @click='toEvaluate' type="button" value="评价">
         <div v-if="evaluateContent">
          <p style="border-bottom: none;">评价内容：<span>{{this.evaluateContent}}</span></p>
          <p style="border-bottom: none;">到场时间：<img style="position: static;" v-for="(star,index) in arriveDateList" :key="index" :src="star.src"/></p>
          <p style="border-bottom: none;">专业水平：<img style="position: static;" v-for="(star,index) in majorLevelList" :key="index" :src="star.src"/></p>
          <p style="border-bottom: none;">服务态度：<img style="position: static;" v-for="(star,index) in serviceAttitudeList" :key="index" :src="star.src"/></p>
         </div>
       </div>
     </div>
  </div>
</template>
<script>
  //黑星星的路径
  const starOff ='../../../../static/img/wjx-old.png';
  //亮星星的路径
  const starOn='../../../../static/img/wjx-new.png';
	//微信接口
	import wx from 'weixin-js-sdk';
  import FiveStars from '../../son/fiveStars.vue'
export default{
	components:{
			FiveStars:FiveStars
		},
  data () {
    return {
    	status:0,
      currentSrc:'',
      currentUrl:[],
    	items:{type:'',
    				 address:'',
    				 content:'',
    				 imgs:[],
    				 srcimgs:[]
    				},
			one:true,
			two:false,
			three:false,
			four:false,
			five:false,
		  finished:[],  //已完成的状态显示的照片      包括维修开始和维修结束的照片
  		receivePerson:'',  //接单人
  		mobile:'',  //接单人的电话
  		receiveDate:'',   //接单时间
  		beginDate:'',   //开始时间
  		finishDate:'',   //完成时间
      evaluateContent: '',
      arriveDateList: [
        // {src: starOn},
        // {src: starOff},
        // {src: starOff},
        // {src: starOff},
        // {src: starOff},
      ],
      arriveDateNum: '',
      majorLevelList: [
        // {src: starOn},
        // {src: starOff},
        // {src: starOff},
        // {src: starOff},
        // {src: starOff},
      ],
      majorLevelNum: '',
      serviceAttitudeList: [
        // {src: starOn},
        // {src: starOff},
        // {src: starOff},
        // {src: starOff},
        // {src: starOff},
      ],
      serviceAttitudeNum: '',
    	}
  },
  mounted(){
    let vm = this
//	console.log(this.$route.params)
  	vm.postRequest('/wo/detail',{
  		id:vm.$route.params.id
  	},function (data) {
      vm.items.type=data.maintenancetype
      vm.items.address=data.address
      vm.items.content=data.billcontent //报修内容
      for(let i=0; i<data.repairpsns.length;i++){
        if(data.repairpsns[i].responsible==="Y"){
          vm.receivePerson=data.repairpsns[i].psnname  //接单人名字
          vm.mobile=data.repairpsns[i].psnmobile  //接单人手机
        }
      }
      vm.receiveDate=data.receivedate   //接单时间
      vm.beginDate=data.begindate   //开始时间
      vm.finishDate=data.maintenanceenddate    //完成时间
      vm.items.imgs=data.submitImages
      //显示报修图片地址
      for(let i=0;i<data.submitImages.length;i++){
        vm.items.srcimgs.push(data.submitImages[i].path)
      }
      //获取维修开始的图片和维修结束的图片  都是缩略图的url
      let beginimg=[],endimg=[]
      data.beginimg.forEach((value)=>{
        beginimg.push(value)  //维修开始的照片
        vm.items.srcimgs.push(value.fileurl)
      })
      data.endimg.forEach((value)=>{
        endimg.push(value)  //维修结束的照片
        vm.items.srcimgs.push(value.fileurl)
      })
      //判断评价内容的评级
      vm.evaluateContent=data.evaluate.evaluationContent //评价内容
      vm.arriveDateNum = data.evaluate.arriveDate
      vm.majorLevelNum = data.evaluate.majorLevel
      vm.serviceAttitudeNum = data.evaluate.serviceAttitude
      switch (vm.arriveDateNum){
        case '1' :
          vm.arriveDateList=[
            {src: starOn},
            {src: starOff},
            {src: starOff},
            {src: starOff},
            {src: starOff},]
          break;
          case '2' :
          vm.arriveDateList=[
            {src: starOn},
            {src: starOn},
            {src: starOff},
            {src: starOff},
            {src: starOff},]
          break;
          case '3' :
          vm.arriveDateList=[
            {src: starOn},
            {src: starOn},
            {src: starOn},
            {src: starOff},
            {src: starOff},]
          break;
          case '4' :
          vm.arriveDateList=[
            {src: starOn},
            {src: starOn},
            {src: starOn},
            {src: starOn},
            {src: starOff},]
          break;
          case '5' :
          vm.arriveDateList=[
            {src: starOn},
            {src: starOn},
            {src: starOn},
            {src: starOn},
            {src: starOn},]
          break;
      }
      switch (vm.majorLevelNum){
        case '1' :
          vm.majorLevelList=[
            {src: starOn},
            {src: starOff},
            {src: starOff},
            {src: starOff},
            {src: starOff},]
          break;
        case '2' :
          vm.majorLevelList=[
            {src: starOn},
            {src: starOn},
            {src: starOff},
            {src: starOff},
            {src: starOff},]
          break;
        case '3' :
          vm.majorLevelList=[
            {src: starOn},
            {src: starOn},
            {src: starOn},
            {src: starOff},
            {src: starOff},]
          break;
        case '4' :
          vm.majorLevelList=[
            {src: starOn},
            {src: starOn},
            {src: starOn},
            {src: starOn},
            {src: starOff},]
          break;
        case '5' :
          vm.majorLevelList=[
            {src: starOn},
            {src: starOn},
            {src: starOn},
            {src: starOn},
            {src: starOn},]
          break;
      }
      switch (vm.serviceAttitudeNum){
        case '1' :
          vm.serviceAttitudeList=[
            {src: starOn},
            {src: starOff},
            {src: starOff},
            {src: starOff},
            {src: starOff},]
          break;
        case '2' :
          vm.serviceAttitudeList=[
            {src: starOn},
            {src: starOn},
            {src: starOff},
            {src: starOff},
            {src: starOff},]
          break;
        case '3' :
          vm.serviceAttitudeList=[
            {src: starOn},
            {src: starOn},
            {src: starOn},
            {src: starOff},
            {src: starOff},]
          break;
        case '4' :
          vm.serviceAttitudeList=[
            {src: starOn},
            {src: starOn},
            {src: starOn},
            {src: starOn},
            {src: starOff},]
          break;
        case '5' :
          vm.serviceAttitudeList=[
            {src: starOn},
            {src: starOn},
            {src: starOn},
            {src: starOn},
            {src: starOn},]
          break;
      }

      //判断工单状态
      switch (data.pstateNum){
        case 1:
          vm.one=true;
          break;
        case 2:
          vm.one=true
          vm.two=true
          break;
        case 3:
          vm.one=true
          vm.two=true
          vm.three=true
          break;
        case 4:
          vm.one=true
          vm.two=true
          vm.three=true
          vm.four=true
          //获取维修开始的图片和维修结束的图片  都是缩略图的url
          vm.finished = beginimg.concat(endimg)
          break;
        case 5:
          vm.one=true
          vm.two=true
          vm.three=true
          vm.four=true
          vm.five=true
          //获取维修开始的图片和维修结束的图片  都是缩略图的url
          vm.finished = beginimg.concat(endimg);
          break;
      }
      vm.status=data.pstateNum
      vm.wxConfig()
    })
  },
  methods: {
		  	beforeRouteEnter (to, from, next){
		  		console.log(from)
		  	},
        //去往评价页面
				toEvaluate(){
					this.$router.push({name:'evaluate',params:{id: this.$route.params.id}})
				},
        wxConfig () {
          let vm = this
          vm.postRequest('wxSign/jsSDKSign', {
            url:window.location.href
          },function (data) {
            vm.currentUrl=vm.items.srcimgs.concat(vm.finished);
            wx.config({
              appId: sessionStorage.getItem('appId'), // 必填，公众号的唯一标识
              timestamp: data.timestamp , // 必填，生成签名的时间戳
              nonceStr: data.noncestr, // 必填，生成签名的随机串
              signature: data.signature, // 必填，签名，见附录1
              jsApiList: ['previewImage'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });
          })
        },
				Big(value){
		  	  let _this = this
          _this.currentSrc=value;
          wx.previewImage({
            current: _this.currentSrc, // 当前显示图片的http链接
            urls: _this.currentUrl // 需要预览的图片http链接列表
          });
				},
				phone(){
					window.location.href = 'tel://' + this.mobile;
				}
		}
 }
</script>
<style scoped lang="less">
#repair{
	width:100%;
  background: #fff;
  .orange{
    font-size:30px;
    color: #F7B932;
    line-height: 84px;
  }
  .orange .p1{
    width:120px;
    height:3px;
    background-color: #F7B932;
    margin-top: 8px;
  }
	.orange .p2{
    width:18px;
    height:18px;
		border-radius: 50%;
		background-color: #F7B932;
    z-index: 999;
	}
	.black{
    font-size:30px;
		color: #ccc;
    line-height: 84px;
	}
  .black .p1{
    width:120px;
    height:3px;
    background-color: #EBEBEB;
    margin-top: 8px;
  }
	.black .p2{
    width:18px;
    height:18px;
    border-radius: 50%;
    background-color: #EBEBEB;
	}
	/*上面5个圆圈*/
	.fiveStatus{
		width:100%;
		height:200px;
    font-size: 32px;
		border-bottom:10px solid #EBEBEB;
		padding:0 30px;
		box-sizing: border-box;
		margin: 0 auto;
    .ul1{
      overflow: hidden;
      zoom: 1;
      padding-top: 50px;
      box-sizing: border-box;
      li{
        display: inline-block;
        margin-left: -10px;
        p{
          float: left;
        }
      }
    }
		.ul2{
			padding-top:10px;
			box-sizing: border-box;
      display: flex;
      justify-content:space-around;
		}
	};
	/*报修相关的具体内容*/
	.aboutRepair{
		padding:0 30px;
		box-sizing: border-box;
		font-size: 32px;
		border-bottom:10px solid #EBEBEB;
		/*报修内容部分*/
		.type{
      margin-top: 70px;
			line-height: 36px;
		}
		.address{
      margin-top: 39px;
			line-height: 50px;
		}
		p{ /*报修内容 */
      margin-top: 33px;
			text-align: left;
			line-height: 36px;
			position:relative;
			span{
				font-size:28px;
				color:#999;
      };
		};
		.contentTitle{
				border-bottom: none;
		}
		.content{
				padding-right: 30px ;
				line-height: 45px;
				border-bottom: none;
 				font-size: 26px;
 				color: #999;
			}
		ul{  /*报修图片*/
			margin:50px 0 30px 0;
			padding-right:30px;
			padding-left: 30px;
			box-sizing: border-box;
			display: flex;
			/*justify-content: initial;*/
			li{
				float:left;
				img{
					width:120px;
					height:120px;
					margin-right: 50px;
				}
			}
		}
	};
	/*接单相关内容*/
	.receive{
		padding-left: 30px;
		box-sizing: border-box;
		display: block;
		p{
			font-size:32px;
			line-height: 88px;
			text-align: left;
			position:relative;
			border-bottom:1px solid #ededed;
			span{
				color: #999;
				font-size: 28px;
			}
			img{  /* 打电话的图标*/
				width:40px;
				height:40px;
				position:absolute;
				right:290px;
				bottom:28px;
			}
		};
		:first-child{
			span{
				margin-left: 40px;
			}
		}
		ul{  /*图片*/
			margin:60px 0 30px 0;
			padding-right:30px;
			padding-left: 30px;
			box-sizing: border-box;
			display: flex;
			li{
				float:left;
				height:120px;
				img{
					width:120px;
					height:120px;
          margin-right: 50px;
				}
			}
		}
	/*评价*/
    .evaluatePart{
      p{
        font-size:30px;
        text-align: left;
        line-height: 88px;
        img{
          width:40px;
          margin-right: 10px;
          vertical-align: middle;

        }
      };
    }
	};

	/*评价按钮*/
	.evaluateBtn{
			width:90%;
			height:90px;
			background-color: #F7B632;
			border-radius: 90px;
			box-sizing: border-box;
			font-size: 32px;
			color:#fff;
			margin:40px 0px ;
			// margin-left: 50%;
			// transform: translateX(-50%);
		};
	.clearfix:after{
            display: block;
            content:'';
            clear: both;
            height:0;
        };
  .hide{
  	display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pub-component/repair/repairDetails.vue